/**
 * @file 标记详情
 * @author wangzhuang
 */
import React from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {withRouter} from 'react-router-dom';
import './index.less';

export class InfoMark extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            type: false,
            formData: {},
            status: 1,
            modTop: 290,
            checkboxValue: false
        };
    }

    componentDidMount() {

        this.scrollFn();
        window.addEventListener('scroll', this.scrollFn);
    }

    formItemGetValue = ({name, value}) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
    };

    scrollFn = () => {
        let scrollTop = document.documentElement.scrollTop;
        if (scrollTop > 150) {
            this.setState({
                modTop: 150
            });
        } else {
            this.setState({
                modTop: 290 - scrollTop
            });
        }
    };

    render() {

        let status = this.state.status;


        let imgType = '';
        let title = '';
        // let color = '';
        let text = '';

        const titleClass = classnames({
            'info-mod': true,
            'success': status === 1,
            'error': status === 2,
            'ing': status === 3
        });

        switch (status) {
            case 1:
                imgType = 'icon_success';
                title = '审核通过';
                // color = '#40C87F';
                text = '恭喜您，提交的资料和号码已完成审核，您可以通过百度搜索相关数据查看';
                break;

            case 2:
                imgType = 'icon_error';
                title = '审核未通过';
                // color = '#FF5F67';
                text = '很抱歉，您提交的企业资质属于不收录的范围';
                break;

            case 3:
                imgType = 'icon_toast';
                title = '审核中';
                // color = '#FFF';
                text = <div>
                    <div>您当前提交的资质和号码，已经到审核阶段，工作人员正在快马加鞭的进行审核</div>
                    <div>我们会在7个工作日内完成审核，请您耐心等待</div>
                </div>;
                break;
        }

        return (
            <div className={'InfoAttest'}>
                <div className={titleClass}>
                    <div className={'top'}/>
                    <div className={'con'}>
                        <div className={'left'}>
                            <div className={'title'}>
                                <img src={require(`../../asset/img/infoAttest/${imgType}.png`)} alt=""/>
                                <div>{title}</div>
                            </div>
                            <div className={'text'}>
                                {text}
                            </div>
                        </div>
                        <div className={'right'}>
                            提交时间：2020-02-20<br/>
                            更新时间：2020-02-20<br/>
                            到期时间：2020-02-20
                        </div>
                    </div>
                </div>

                <div className={'info-from'}>
                    <div className={'mod-title'}>
                        号码标记
                    </div>

                    <div className={'mt20'}>
                        <div className={'mod-label'}>
                            <div className={'left'}>
                                <i className={'star'}>*</i><span>标记号码</span>
                            </div>
                            <div className={'right'}>
                                23232
                            </div>
                        </div>

                        <div className={'mod-label'}>
                            <div className={'left'}>
                                <i className={'star'}>*</i><span>标记类型</span>
                            </div>
                            <div className={'right'}>
                                骚扰电话
                            </div>
                        </div>

                        <div className={'mod-label'}>
                            <div className={'left'}>
                                <i className={'opacity'}>*</i><span>标记原因</span>
                            </div>
                            <div className={'right'}>
                                这是一段话
                            </div>
                        </div>


                    </div>
                </div>


            </div>
        );
    }
}

InfoMark.propTypes = {};

function mapStateToProps() {
    return {};
}

function mapDispatchToProps() {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InfoMark));